import { Main } from 'components/Shared/Layout';
import { Panorama } from 'components/Panorama';
import connect from 'components/Shared/connect';
import { resource as rm } from 'utils';
import { SectionPageModel } from 'models/SectionPageModel';
import { MostPopularProducts } from 'components/MostPopularProducts';
import { CountdownAd } from 'components/CountdownAd';
import ImageAds from 'components/ImageAds';
import styles from './styles.scss';
import SectionDescription from './sectionDescription';
import { InfoBlock } from 'components/Shared/InfoBlock';

interface MergedProps extends SectionPageModel {
  gotoOfferText: string;
  mostPopularProductsTitle: string;
  productGoto: string;
  showAllCategories: string;
  header: string;
  longDescription: string;
}

const SectionPage = ({
  countdownAd,
  gotoOfferText,
  takeoverAd,
  sliderAds,
  productGoto,
  mostPopularProductsTitle,
  mostPopularProducts,
  smallImageOneThirdAds,
  header,
  longDescription
}: MergedProps) => (
  <Main className={styles.sectionPage}>
    {countdownAd && <CountdownAd {...countdownAd} />}
    {sliderAds && sliderAds.length > 0 && (
      <Panorama {...{ takeoverAd, sliderAds, gotoOfferText }} />
    )}
    <SectionDescription />
    <ImageAds ads={smallImageOneThirdAds} />
    <MostPopularProducts
      className={styles.gopMostPopularProducts}
      {...{ productGoto, mostPopularProductsTitle, mostPopularProducts }}
    />
    <InfoBlock {...{ header, longDescription }} />
  </Main>
);

export default connect<MergedProps>(({ currentPage, appShell }) => ({
  gotoOfferText: rm(appShell, 'ads_offer_linktext'),
  mostPopularProductsTitle: rm(appShell, 'toplist_product_header'),
  productGoto: rm(appShell, 'product_goto'),
  sliderAds: (currentPage as SectionPageModel).sliderAds,
  smallImageOneThirdAds: (currentPage as SectionPageModel).smallImageOneThirdAds,
  countdownAd: (currentPage as SectionPageModel).countdownAd,
  mostPopularProducts: (currentPage as SectionPageModel).mostPopularProducts,
  showAllCategories: rm(appShell, 'navigation_seeallcountcategories'),
  header: (currentPage as SectionPageModel).header,
  longDescription: (currentPage as SectionPageModel).longDescription
}))(SectionPage);
